import { render, staticRenderFns } from "./AddCategoryDialog.vue?vue&type=template&id=712bab3d&scoped=true&"
import script from "./AddCategoryDialog.vue?vue&type=script&lang=ts&"
export * from "./AddCategoryDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712bab3d",
  null
  
)

export default component.exports